import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { setItem } from 'api/actions';
import _ from 'lodash';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function OTPModuleContent({
  handleEdit,
  otpItemId,
  showOTPSettings,
  getSingleOTPItem,
}) {
  const dispatch = useDispatch()

  useEffect(() => {
    if (_.isEmpty(otpItemId)) return;
    showOTPSettings(otpItemId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(otpItemId)) return;
    showOTPSettings(otpItemId);
  }, [otpItemId]);

  useEffect(() => {
    // dispatch opt data to ProfileEditModal.js (for subscribers)
    dispatch(setItem(c.DISPATCHED_OTP_DATA, {
      registered_account: _.get(getSingleOTPItem, 'attributes.register_account'),
      change_mobile_number: _.get(getSingleOTPItem, 'attributes.change_mobile_number')
    }))
  }, [_.get(getSingleOTPItem, 'attributes.register_account'), _.get(getSingleOTPItem, 'attributes.change_mobile_number')])

  return (
    <div className="container-fluid card-section-content">
      {!_.isEmpty(getSingleOTPItem) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div className="col-8">
                  <h3 className="">
                    {' '}
                    {_.get(getSingleOTPItem, 'attributes.type') ||
                      '--'}
                  </h3>
                </div>
                <div className="col-4 d-flex">
                  <div className="ml-auto">
                    <button
                      type="button"
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  py-"
                      onClick={handleEdit(getSingleOTPItem)}
                    >
                      <i className="far fa-edit mr-2" />
                      Update OTP
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-12">
                    <div className="form-wrapper mb-3">
                      <div className="full-group border-bottom">
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">
                              Change Mobile No:
                            </label>
                            <span className="full-input">
                              {_.get(getSingleOTPItem, 'attributes.change_mobile_number') === 0 ? <div className="btn btn-sm btn-danger" style={{ borderRadius: '40px' }}>INACTIVE</div> : <div className="btn btn-sm btn-success btn-rounded" style={{ borderRadius: '40px' }}>ACTIVE</div> || '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">Register Account:</label>
                            <span className="full-input">
                              {_.get(getSingleOTPItem, 'attributes.register_account') === 0 ? <div className="btn btn-sm btn-danger" style={{ borderRadius: '40px' }}>INACTIVE</div> : <div className="btn btn-sm btn-success btn-rounded" style={{ borderRadius: '40px' }}>ACTIVE</div> || '--'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

OTPModuleContent.propTypes = {
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  showOTPSettings: PropTypes.instanceOf(Function).isRequired,
  getSingleOTPItem: PropTypes.instanceOf(Object).isRequired,
  otpItemId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  getSingleOTPItem: _.get(api, `${c.SHOW_OTP_SETTINGS}.item`) || {},
  otpItemId: _.get(match, 'params.otpId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(OTPModuleContent);
